"use client"
import React, { useEffect, useState } from "react";
import "./middleheader.css";
import Sidebar from "./Sidebar";
import Image from "next/image";
// import { FaAngleDown } from "react-icons/fa";
import Link from 'next/link'
const MiddleHeader = () => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <>
      <div className="Css-bg-desk-middle-header">
        <div className="container-fluid">
          <div className="row">
            <div className={`col-12 Css-center-logo-tab Css-mymobile-sticky-navbar ${isSticky ? 'Css-mobile-sticky' : ''}`}>
              <div className="d-block d-xl-none position-relative d-flex align-items-center justify-content-between w-100">

                {/* Left Side (Logo & NABH) */}
                <div className="d-flex align-items-center flex-grow-1">
                  <Link className="navbar-brand" href="/">
                    <Image
                      src="https://cdn.dotplus.in/Cloud/Aarogyam/logo/HDNA_Aarogyam_Hospital_Logo.png"
                      alt="HDNA Aarogyam Hospital Official Logo - High Quality"
                      width={170}
                      height={48}
                      priority
                    />
                  </Link>
                  <Link className="navbar-brand" href="/">
                    <Image
                      src="/images/nabh-new.webp"
                      alt="NABH Accreditation Badge - HDNA Aarogyam Hospital"
                      width={60}
                      height={42}
                      priority
                    />
                  </Link>
                </div>

                {/* Right Side (Sidebar button) */}
                {/* <div>
                  <Sidebar />
                </div> */}
                <div className="header-icons-css">
                  <div className="icon-item">
                    <Link href="https://api.whatsapp.com/send/?phone=+918544015151&text=Hi+I+am+messaging+clicking+on+the+website+https://aarogyamhdna.com/&type=phone_number&app_absent=0" target="_blank">
                      <Image
                        src="/images/footer-menu/whatsapp.png"
                        alt="WhatsApp Icon"
                        width={30}
                        height={30}
                      />
                      <span>WhatsApp</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MiddleHeader;
